import { Alert } from 'antd';
import ErrorBoundary from 'antd/es/alert/ErrorBoundary';
export * from 'react-text-loop';
export { ErrorBoundary };
export default Alert;
